import { css } from 'styled-components';
import _get from 'lodash/get';
import { pxToRem, fontSizeLarge, breakpoint } from '@fil-react-mixins/styled';
export const statusColors = {
    success: 'green.600',
    warning: 'orange.400',
    info: 'blue.500',
    error: 'red.500',
};
export default css `
  background: ${(props) => props.theme.color.base.grey['025'].value};
  position: relative;
  text-align: left;

  ::before {
    content: '';
    width: 0.25rem;
    background: ${({ theme, status = 'success' }) => _get(theme.color.base, `${statusColors[status]}.value`)};
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
  }

  .fil-notification {
    &__close {
      position: absolute;
      top: 1rem;
      right: 1rem;
      width: 1rem;
      height: 1rem;
      cursor: pointer;
      border: none;
      font-size: 1rem;
      ${breakpoint('lg', css `
          top: 1.25rem;
          right: 1.25rem;
        `)}

      &:hover,
      &:focus {
        color: ${(props) => props.theme.color.base.blue['500'].value};
      }

      &.focus-visible {
        outline-offset: ${pxToRem(12)};
      }
    }

    &__body {
      position: relative;
      padding: ${pxToRem(50)} 1rem ${pxToRem(14)} 1.25rem;
      ${breakpoint('lg', css `
          padding: 1rem 1.25rem ${pxToRem(22)} 4.75rem;
          ${({ closable = true }) => closable &&
    css `
              padding-right: 3.5rem;
            `}

          ${(props) => !props.title &&
    css `
              padding-top: ${pxToRem(19)};
            `}
        `)}
      ${({ showIcon = true }) => !showIcon &&
    css `
          padding-left: 1.25rem;
          padding-top: 1rem;
          ${breakpoint('lg', css `
              padding-left: 1.5rem;
              padding-top: 1.25rem;
            `)}
        `}
    }

    &__icon {
      position: absolute;
      top: 1rem;
      left: 1.25rem;
      line-height: 1;

      svg {
        width: 1.5rem;
        height: 1.5rem;
        stroke-width: 1.5;
      }

      ${breakpoint('lg', css `
          top: 1.25rem;
          left: 1.5rem;

          svg {
            width: 2rem;
            height: 2rem;
            stroke-width: 1.5;
          }
        `)}
    }

    &__title {
      ${fontSizeLarge}
      margin-bottom: 0;
      font-weight: bold;
      ${(props) => props.status === 'error' &&
    css `
          color: ${props.theme.color.base.red['500'].value};
        `}

      + * {
        margin-top: ${pxToRem(5)};
      }
    }

    &__text {
      > p:last-child {
        margin-bottom: 0;
      }
    }

    &__link {
      margin-top: ${pxToRem(10)};
      margin-bottom: 0.5rem;
      display: inline-block;
      ${breakpoint('lg', css `
          margin-bottom: 0;
        `)}
    }
  }
`;
